export default __webpack_public_path__ + "static/charmverse-63d2ca2ad08e631c4c2c4578e01ff0c9.jpg";